import { blue, gray } from "@ant-design/colors";
import {
  Button,
  Card,
  Col,
  Divider,
  Flex,
  Image,
  Row,
  Skeleton,
  Space,
  Typography,
} from "antd";
import ServiceApi from "apis/ServiceApi";
import { showNotification } from "common";
import HeaderLogo from "components/HeaderLogo";
import { OBJECT_LABEL_EXTEND } from "constants/objectCompensation";
import { formatterNumber } from "helpers/formatNumber";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { WarningOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  ArrowLeftOutlined,
} from "@ant-design/icons";
export default function OrderPayment() {
  const location = useLocation();
  const { Text } = Typography;
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");
  const object = searchParams.get("object");
  const requestId = searchParams.get("requestId");
  const checkGiaHan = object === "2";
  const [dataPayment, setDataPayment] = useState();
  const [dataPackage, setDataPackage] = useState();
  const history = useHistory();
  // const imgBank =
  //   "https://img.vietqr.io/image/vietinbank-113366668888-compact2.jpg?amount=790000&addInfo=dong%20gop%20quy%20vac%20xin&accountName=Quy%20Vac%20Xin%20Covid";

  const [loading, setLoading] = useState(true);

  const fetchDetailPackage = async (dataInfoOrder) => {
    if (!type) return;
    setLoading(true);
    try {
      const res = await ServiceApi.getListPackageExtend({
        object: type,
      });
      if (res?.data?.status === 200) {
        const newArr = res?.data?.data?.map((item) => ({
          ...item,
          value: item.id,
          label:
            OBJECT_LABEL_EXTEND.find(
              (itemL) => itemL.value === item?.extendType
            )?.label ?? item.name,
        }));
        const packageFind = newArr.find(
          (item) => item.code === dataInfoOrder.packageCode
        );
        setDataPackage(packageFind);
        return newArr;
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };

  const fetchDataPayment = async () => {
    setLoading(true);
    try {
      const res = await ServiceApi.getInformationOrder({
        object,
        type,
        requestId,
      });
      if (res && res.status === 200 && res.data.data) {
        setDataPayment(res.data.data);
        fetchDetailPackage(res.data.data);
      }
    } catch (error) {
      console.error("error: ", error);
      showNotification("error", error.response.data.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, object]);

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div>
      <Flex justify="center">
        <HeaderLogo />
      </Flex>
      <Row gutter={16} className="my-3">
        <Col span={12}>
          <Card title="Thông tin đơn hàng">
            <Flex justify="space-between">
              <div>Dịch vụ:</div>
              <div>
                <Typography.Text strong right>
                  {checkGiaHan
                    ? "Gia hạn chứng thư số"
                    : "Điều chỉnh thông tin"}
                </Typography.Text>
              </div>
            </Flex>
            <Flex justify="space-between">
              <div>Gói dịch vụ:</div>
              <div>
                <Typography.Text strong>
                  {checkGiaHan ? dataPackage?.label : dataPayment?.packageName}
                </Typography.Text>
              </div>
            </Flex>
            <Flex justify="space-between">
              <div>Giá niêm yết:</div>
              <div>
                <Typography.Text strong>
                  {formatterNumber(dataPayment?.unitPrice)} VNĐ
                </Typography.Text>
              </div>
            </Flex>
            {dataPayment?.specialPrice && (
              <Flex justify="space-between">
                <Typography.Title
                  level={4}
                  strong
                  type="danger"
                  style={{ margin: 0 }}
                >
                  Giá ưu đãi:
                </Typography.Title>
                <div>
                  <Typography.Title
                    level={4}
                    strong
                    type="danger"
                    style={{ margin: 0 }}
                  >
                    {formatterNumber(dataPayment?.specialPrice)} VNĐ
                  </Typography.Title>
                </div>
              </Flex>
            )}
            {/* <Flex justify="space-between">
              <div>Khuyến mại</div>
              <div>
                <Typography.Text strong>
                  {formatterNumber(dataPayment?.discount)} VNĐ
                </Typography.Text>
              </div>
            </Flex> */}
            <Divider />
            <Flex justify="space-between">
              <div>
                <Typography.Title
                  level={5}
                  type="primary"
                  style={{ color: blue.primary, margin: 0 }}
                >
                  Tổng thanh toán:
                </Typography.Title>
              </div>
              <div>
                <Typography.Title
                  level={5}
                  style={{ color: blue.primary, margin: 0 }}
                >
                  {formatterNumber(dataPayment?.totalPayment)} VNĐ
                </Typography.Title>
              </div>
            </Flex>
            <Flex justify="space-between">
              <div>
                <Typography.Text type="danger">
                  <small>(* Giá đã bao gồm thuế VAT)</small>
                </Typography.Text>
              </div>
            </Flex>
            <br />
            <Flex>
              <div>
                <Space>
                  <Text type="danger">
                    <WarningOutlined />
                  </Text>
                  <Text type="danger" strong>
                    Lưu ý:
                  </Text>
                </Space>
                <div>
                  <Text italic>
                    Quý khách hàng vui lòng kiểm tra chính xác thông tin số tài
                    khoản, tên người nhận trước khi thực hiện thanh toán
                  </Text>
                </div>
              </div>
            </Flex>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Quét mã QR để thực hiện thanh toán">
            <Flex justify="center">
              {loading && (
                <Skeleton.Image style={{ width: 400, height: 400 }} />
              )}
            </Flex>
            <Flex justify="center">
              <Image
                width={350}
                height="auto"
                src={dataPayment?.qrCodeLink}
                alt="qr-thanh-toan"
                onLoad={() => setLoading(false)}
                style={{ display: loading ? "none" : "block" }}
              />
            </Flex>
          </Card>
        </Col>
      </Row>
      <Row justify={"center"}>
        <Button type="primary" htmlType="button"
            icon={<ArrowLeftOutlined />}
          style={{ background: gray.primary }}
          onClick={handleGoBack}
        >
          Quay lại
        </Button>
      </Row>
    </div>
  );
}
